/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'
import Title from './Title'

const MyContact = (props): JSX.Element => {
  const { data, title } = props
  const chartData = data.map((item, index) => {
    const temp = {
      name: item.title,
    }
    temp[`value${index + 1}`] = item.value
    return temp
  })
  const containerProps = {
    minWidth: 200,
    height: 200,
    aspect: 1.5,
  }
  return (
    <div>
      <Title>{title}</Title>
      <ResponsiveContainer {...containerProps}>
        <BarChart
          width={300}
          height={200}
          data={chartData}
          margin={{
            top: 5,
            left: -20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip />
          <Bar dataKey="value1" fill="#2A2AE0" />
          <Bar dataKey="value2" fill="#E349A8" />
          <Bar dataKey="value3" fill="#09B724" />
        </BarChart>
      </ResponsiveContainer>
      {title.includes('NEW') && (
        <div className="explanation pie-chart">
          {data.map(item => (
            <div className="item" key={item.title}>
              <div className="item-square" style={{ background: item.color }} />
              <p className="item-text">{item.title}</p>
            </div>
          ))}
        </div>
      )}
      {!title.includes('NEW') && (
        <>
          <div className="explanation">
            <div className="item">
              <div className="item-square" style={{ background: '#E349A8' }} />
              <p className="item-text">REV-UP</p>
            </div>
            <div className="item">
              <div className="item-square" style={{ background: '#09B724' }} />
              <p className="item-text">ENGAGED</p>
            </div>
          </div>
          <div className="explanation">
            <div className="item">
              <div className="item-square" style={{ background: '#2A2AE0' }} />
              <p className="item-text">RE-ENGAGE</p>
            </div>
          </div>
        </>
      )}
    </div>
  )
}
export default MyContact
